<template>
  <div
    ref="emojiPickerDialog"
    :class="{
      'emoji-picker': true,
      'emoji-picker-h5': !isPC,
    }"
  >
    <ul
      ref="emojiPickerListRef"
      :class="['emoji-picker-list', !isPC && 'emoji-picker-h5-list']"
    >
      <li
        v-for="(childrenItem, childrenIndex) in currentEmojiList"
        :key="childrenIndex"
        class="emoji-picker-list-item"
        @click="select(childrenItem, childrenIndex)"
      >
        <img
          class="emoji"
          :src="BASIC_EMOJI_URL + BASIC_EMOJI_URL_MAPPING[childrenItem]"
        >
<!--        <img-->
<!--          v-else-if="currentTabItem.type === EMOJI_TYPE.BIG"-->
<!--          class="emoji-big"-->
<!--          :src="currentTabItem.url + childrenItem + '@2x.png'"-->
<!--        >-->
<!--        <img-->
<!--          v-else-->
<!--          class="emoji-custom emoji-big"-->
<!--          :src="currentTabItem.url + childrenItem"-->
<!--        >-->
      </li>
    </ul>
    <ul class="emoji-picker-tab">
<!--      <li-->
<!--        v-for="(item, index) in list"-->
<!--        :key="index"-->
<!--        class="emoji-picker-tab-item"-->
<!--        @click="toggleEmojiTab(index)"-->
<!--      >-->
<!--        <Icon-->
<!--          v-if="item.type === EMOJI_TYPE.BASIC"-->
<!--          class="icon"-->
<!--          :file="faceIcon"-->
<!--        />-->
<!--        <img-->
<!--          v-else-if="item.type === EMOJI_TYPE.BIG"-->
<!--          class="icon-big"-->
<!--          :src="item.url + item.list[0] + '@2x.png'"-->
<!--        >-->
<!--        <img-->
<!--          v-else-->
<!--          class="icon-custom icon-big"-->
<!--          :src="item.url + item.list[0]"-->
<!--        >-->
<!--      </li>-->
      <li
        v-if="isH5"
        class="send-btn"
        @click="sendMessage"
      >
      {{ TUITranslateService.t("发送") }}
      </li>
    </ul>
  </div>
</template>
<script lang="ts" setup>
import vue from '../../../../adapter-vue';
import {
  TUIChatService,
  TUIStore,
  StoreName,
  IConversationModel,
  SendMessageParams,
  TUITranslateService
} from '../../../../@aidesk/uikit-engine';
import { isPC, isH5 } from '../../../../utils/env';
import { IEmojiGroupList, IEmojiGroup } from '../../../../interface';
import { isEnabledMessageReadReceiptGlobal } from '../../../../utils/utils';
import {
  EMOJI_GROUP_LIST,
  BASIC_EMOJI_URL_MAPPING,
  convertKeyToEmojiName,
  BASIC_EMOJI_URL,
  filterEmojisInNonChineseEnv,
} from '../../emoji-config';
const { ref, onMounted, onUnmounted } = vue;

const emits = defineEmits(['insertEmoji', 'onClose', 'sendMessage']);
const currentConversation = ref();
const emojiPickerDialog = ref();
const emojiPickerListRef = ref();
const list = ref<IEmojiGroupList>(EMOJI_GROUP_LIST);
const currentEmojiList = ref<string[]>(list?.value[0]?.list);

onMounted(() => {
  TUIStore.watch(StoreName.CONV, {
    currentConversation: onCurrentConversationUpdate,
  });
  currentEmojiList.value = filterEmojisInNonChineseEnv(list.value[0].list);
});

onUnmounted(() => {
  TUIStore.unwatch(StoreName.CONV, {
    currentConversation: onCurrentConversationUpdate,
  });
});

const select = (item: any, index: number) => {
  const options: any = {
    emoji: { key: item, name: convertKeyToEmojiName(item) },
    type: 'basic',
  };
  options.url = BASIC_EMOJI_URL + BASIC_EMOJI_URL_MAPPING[item];
  emits('insertEmoji', options);
  isPC && emits('onClose');
};

const sendFaceMessage = (index: number, listItem: IEmojiGroup) => {
  const options = {
    to:
      currentConversation?.value?.groupProfile?.groupID
      || currentConversation?.value?.userProfile?.userID,
    conversationType: currentConversation?.value?.type,
    payload: {
      index: listItem.emojiGroupID,
      data: listItem.list[index],
    },
    needReadReceipt: isEnabledMessageReadReceiptGlobal(),
  } as SendMessageParams;
  TUIChatService.sendFaceMessage(options);
};

function sendMessage() {
  emits('sendMessage');
}

function onCurrentConversationUpdate(conversation: IConversationModel) {
  currentConversation.value = conversation;
}
</script>

<style lang="scss" scoped src="./style/index.scss"></style>
